module.exports = "/images/model_0fc547.png";